module.exports = __webpack_public_path__ + "static/media/comfort-keepers.1e31334f.png";